/* Which picture represents a video: its uploaded image, else a still frame taken from its stream. */

/** Smallest renditions first: a frame only needs the first segment of the lightest stream. */
const RENDITION_ORDER = ['270p', '360p', '540p', '720p', '1080p', 'master'];

/** Uploaded thumbnail, then banner image; null when the video has neither. */
export function videoImage(info: any): string | null {
  return info?.video_thumbnail_image || info?.video_banner_image || null;
}

/**
 * The lightest public HLS stream of the video (from `vod_urls`), used to grab a still frame,
 * or null. (The original upload in `video_url` is in a private bucket and cannot be read by browsers.)
 */
export function videoFrameSource(info: any): string | null {
  let urls: any = info?.vod_urls;
  if (typeof urls === 'string') {
    try { urls = JSON.parse(urls); } catch { return null; }
  }
  if (!urls || typeof urls !== 'object') return null;
  const key = RENDITION_ORDER.find(name => typeof urls[name] === 'string' && /\.m3u8(\?|$)/i.test(urls[name]));
  return key ? urls[key] : null;
}

/** The album's picture: its own image, else the first video's image or frame. */
export function albumPictureInfo(albumInfo: any, firstVideoInfo: any): any {
  if (videoImage(albumInfo)) return albumInfo;
  if (videoImage(firstVideoInfo) || videoFrameSource(firstVideoInfo)) return firstVideoInfo;
  return albumInfo;
}
